import type { ReactElement } from "react";

import {
    StyledLeadsBaseContentContainer,
    StyledLeadsTabContent,
    StyledLeadsTableWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { SearchResultsTableBoundary } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { TabContentComponentProps } from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { useIsLeadsPanelDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsPanelDataLoading";
import { LeadsSearchFiltersWithAgent } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { useResetTerritory } from "app/pages/sales-intelligence/modules/teams/hooks/useResetTerritory";
import AccountsExportPreviewModalContainer from "app/pages/sales-intelligence/modules/crm-export/components/AccountsExportPreviewModalContainer/AccountsExportPreviewModalContainer";

import { TerritoryFiltersControlGate } from "../../components/TerritoryFiltersControlGate/TerritoryFiltersControlGate";
import LeadsSearchResultsTableContainer from "../SearchResultsTableContainer/LeadsSearchResultsTableContainer";
import TableActionsPanelContainer from "../table-actions-panel/TableActionsPanel/TableActionsPanelContainer";
import TableSearchRowContainer from "../TableSearchRow/TableSearchRowContainer";

type Props = TabContentComponentProps<PageTabBase<LeadsType>>;

const LeadsTabContentContainer = ({ tab, shouldRenderDeferredContent = true }: Props): ReactElement => {
    const isLeadsPanelDataLoading = useIsLeadsPanelDataLoading();
    const resetTerritory = useResetTerritory();

    return (
        <StyledLeadsTabContent data-automation="tab-content">
            <StyledLeadsBaseContentContainer>
                <LeadsSearchFiltersWithAgent
                    isLoading={isLeadsPanelDataLoading || !shouldRenderDeferredContent}
                    belowSearchSlot={<TerritoryFiltersControlGate />}
                    onClearAllFilters={resetTerritory}
                />
            </StyledLeadsBaseContentContainer>

            <StyledLeadsTableWrapper>
                <TableActionsPanelContainer />
                <TableSearchRowContainer />
                <SearchResultsTableBoundary shouldSuspend={!shouldRenderDeferredContent}>
                    <LeadsSearchResultsTableContainer tab={tab} />
                </SearchResultsTableBoundary>
            </StyledLeadsTableWrapper>
            <AccountsExportPreviewModalContainer />
        </StyledLeadsTabContent>
    );
};

export default LeadsTabContentContainer;
